<script lang="ts">
  import { format } from "date-fns";
  import Stack from "../../Stack.svelte";
  import TextNew from "../../TextNew.svelte";

  export let date: Date | undefined;
  export let title: string;
  export let subtitle: string | undefined = undefined;

  $: day = date ? format(date, "dd") : "";
  $: month = date ? format(date, "MMM") : "";
</script>

<div class="container">
  <div class="date">
    <Stack vertical justifyContent="center" alignItems="center">
      <TextNew size="m" weight="medium">{day}</TextNew>
      <TextNew size="xs" font="ocr" --rk-text-color="var(--rk-text-error)">{month}</TextNew>
    </Stack>
  </div>
  <Stack vertical padding="0 16px">
    <TextNew size="m">{title}</TextNew>
    {#if subtitle}
      <TextNew size="s" --rk-text-color="var(--rk-text-low)">{subtitle}</TextNew>
    {/if}
  </Stack>
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .date {
    border: solid 1px var(--rk-divider-0);
    border-radius: 6px;
    padding: 10px;
    width: 48px;
    height: 56px;
  }
</style>
